import FJFaceSwapLeftRightLeftContainer from './FJFaceSwapLeft/FJFaceSwapLeftContainer';
import FJFaceSwapLeftRightRightContainer from './FJFaceSwapLeftRight/FJFaceSwapLeftRightContainer';

const FJFaceSwap = () => {
    return (
        <>
            <FJFaceSwapLeftRightLeftContainer />
            <FJFaceSwapLeftRightRightContainer />
        </>
    );
};

export default FJFaceSwap;
